import {
  SelectContent,
  SelectField,
  SelectItem
} from '@ps-design-system/components/Select';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

export const NEW_CARD_OPTION = {
  label: 'Add a new card',
  value: 'new_card',
  id: 'new_card'
};

export const formatCreditCard = ({ brand, last4, exp_month, exp_year }) => {
  return `${brand} - ${last4} (Exp. ${exp_month}/${exp_year})`;
};

export const CreditCardSelectField = ({
  form,
  name = 'selectedCreditCard',
  disabled,
  customerPaymentMethods,
  fullWidth,
  ...selectProps
}) => {
  const cardOptions = useMemo(() => {
    const cardOptions = (customerPaymentMethods || []).map((card) => {
      if (card.id === 'new_card') {
        return NEW_CARD_OPTION;
      }

      return {
        label: formatCreditCard(card),
        value: card.id,
        ...card
      };
    });
    return [...cardOptions, NEW_CARD_OPTION];
  }, [customerPaymentMethods]);

  return (
    <SelectField
      testId="credit-card-select"
      name={name}
      disabled={disabled}
      fullWidth={fullWidth}
      renderContent={() => (
        <SelectContent>
          {(cardOptions || []).map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      )}
      defaultValue={cardOptions[0]?.value}
      value={form.watch(name)?.id}
      onValueChange={(paymentMethodId) => {
        const paymentMethod =
          paymentMethodId === 'new_card'
            ? NEW_CARD_OPTION
            : (customerPaymentMethods || []).find(
                (item) => item.id === paymentMethodId
              );
        form.setValue(name, paymentMethod);
      }}
      {...selectProps}
    />
  );
};

CreditCardSelectField.displayName = 'CreditCardSelectField';
CreditCardSelectField.propTypes = {
  customerPaymentMethods: PropTypes.array,
  form: PropTypes.object,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool
};
